<template>
  <div class="dashboard-container p-20 position-relative">
    <div class="container-responsive">
      <div class="row">
        <carousel-widget :isDefault="isDefault"></carousel-widget>
        <div
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 marketplace-right"
          v-if="topService && remainingServices"
        >
          <div class="marketing-widget">
            <div class="starting-marketplace">
              <p class="market-title d-flex">
                Explore RAMS
                <span class="new-image center">NEW</span>
              </p>
              <div class="market-place-line p-0">
                <img :src="topService.image_location" class="laptop-image" />
              </div>
              <div class="marketplace-smart-builder">
                <div class="smart-builder market-place-line d-flex p-0">
                  <span>
                    <div class="d-flex">
                      <div
                        class="col-xs-9 col-sm-9 col-md-9 col-lg-9 mr_tp_10 p-0 countries_select_list"
                      >
                        <p class="country-label">Country</p>
                        <multiselect
                          :showLabels="false"
                          :close-on-select="true"
                          :allow-empty="false"
                          class="multiselect-single-dropdown"
                          :searchable="true"
                          :options="countriesData.countries.map((country) => country.country_name)"
                          v-model="country"
                          @input="countrySelected"
                          placeholder="Select"
                        >
                          <span slot="noResult">No matching data</span>
                        </multiselect>
                      </div>
                      <div class="col-xs-2 col-sm-2 col-md-2 mr_tp_10 margin_left">
                        <div
                          v-on:click="
                            country !== '' ? redirect(`/layout/resourcesdashboard`, country) : null
                          "
                          class="btn emergo-green-button button_go"
                        >
                          GO
                        </div>
                      </div>
                    </div>
                    <div class="pt-12">
                      <div class="sub-doc d-flex">
                        <span>{{ topService.description }}</span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="last-marketplace market-place-line p-0">
              <div class="premium-services">Premium Services</div>
              <div
                class="main-reg-intel d-flex"
                v-for="service in remainingServices"
                :key="service.id"
              >
                <img
                  :src="getImageUrl(service.icon_location, true)"
                  class="market-img"
                  :class="{ 'market-img-gg': service.id == 5 }"
                />
                <span class="premium-regulatory">
                  <div
                    class="sub-category"
                    @click="redirect(`/layout/market-place/service/${service.id}`)"
                  >
                    {{ service.name }}
                  </div>
                  <div class="pt-12">
                    <div class="sub-premium">{{ service.description }}</div>
                  </div>
                </span>
              </div>
            </div>
            <span class="see-more marketplace-see-more" @click="redirect(`/layout/market-place`)"
              >Learn more</span
            >
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <div class="notification-widget">
            <div class="widget-card noti-ht">
              <div class="header d-flex align-items-center">
                <img src="/static/images/icons/notification_blue.svg" />
                <h3 class="title m-0">Notifications</h3>
              </div>
              <div
                class="each-notification mt-10"
                v-for="(notificationsPerDate, index) in notificationsList"
                v-bind:key="index"
              >
                <div class="row">
                  <div class="col-xs-5 col-sm-4 col-md-4 col-lg-5 notification-date-css">
                    {{ notificationsPerDate.date | formatDate('DD-MM-YYYY', 'MMM DD, YYYY') }}
                  </div>
                </div>
                <div
                  v-for="(notification, index) in notificationsPerDate.notifications"
                  v-bind:key="index"
                >
                  <div class="pl-14 pt-10">
                    <div>
                      <div class="row notification_text_block d-flex align-items-start">
                        <div v-if="notification.type == 'RW' || notification.type == 'UN'">
                          <span
                            class="flag-icon flag-icon-squared mr-12"
                            :class="notification.icon"
                          ></span>
                        </div>
                        <!-- Reg Tracker OR Reg Watch -->
                        <img
                          class="mr-12 img-size"
                          v-else-if="notification.type == 'SB'"
                          src="/static/images/icons/track_plus_icon_blue.svg"
                          alt
                        />
                        <!-- SB-->
                        <img
                          class="mr-12 img-size"
                          v-else-if="notification.type == 'PC'"
                          src="/static/images/icons/prod_classification_blue.svg"
                          alt
                        />
                        <!-- PC-->
                        <img
                          class="mr-12 img-size"
                          v-else-if="notification.type == 'RP'"
                          src="/static/images/icons/reg_pathway_blue.svg"
                          alt
                        />
                        <!-- RP-->
                        <img
                          class="mr-12 img-size"
                          v-else
                          src="/static/images/icons/smartexchange_icon_blue.svg"
                          alt
                        />
                        <!-- SX-->
                        <span class="notification-details" v-if="notification.type == 'RW'"
                          >New Regulatory update has been published for
                          {{ notification.country_name }}</span
                        >
                        <!-- Reg watch-->
                        <span
                          class="notification-details"
                          v-else-if="
                            notification.type == 'UN' ||
                            notification.type == 'SX' ||
                            notification.type == 'PC' ||
                            notification.type == 'RP'
                          "
                          >{{ notification.title }}</span
                        >
                        <!-- Reg Tracker OR SX OR PC OR RP -->
                        <span v-else>
                          <!-- notification type SB -->
                          <span
                            class="notification-details"
                            v-if="notification.notification_type == 'Project'"
                          >
                            <span v-if="notification.project_action_type == 'Export'"
                              >{{ notification.project_title }}
                              <span v-if="notification.project_status == 'Success'"
                                >has been exported
                              </span>
                              <span v-if="notification.project_status == 'Fail'"
                                >export failed</span
                              >
                            </span>
                            <span v-if="notification.project_action_type == 'Complete'"
                              >The {{ notification.project_title }}
                              <span v-if="notification.project_status == 'Success'"
                                >is 100% complete</span
                              >
                              <span v-if="notification.project_status == 'Fail'"
                                >is not completed</span
                              >
                            </span>
                          </span>
                          <span
                            class="notification-details"
                            v-if="notification.notification_type == 'User Comment'"
                          >
                            <span v-if="notification.comment_type == 'Commented'"
                              >You have been mentioned in {{ notification.project_title }}</span
                            >
                            <!-- comment_type is Replied -->
                            <span v-if="notification.comment_type == 'Replied'"
                              >{{ notification.commentator_name }} have been mentioned in
                              {{ notification.project_title }}</span
                            >
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="footer">
                <span class="see-more" @click="redirect(`/layout/alert`)">See All</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <div class="upcoming-widget">
            <div class="widget-card position-relative">
              <div class="header d-flex">
                <img src="/static/images/icons/featured_content_icon.svg" />
                <h3 class="title m-0">Featured Content</h3>
                <span class="admin-features">
                  <span v-if="roleId === 5 || roleId === 7">
                    <span
                      @click="
                        allFeaturedContent.length >= 12 ? '' : openAddPopup('Featured Content')
                      "
                      :class="
                        allFeaturedContent.length >= 12
                          ? 'cursor-pointer-disable'
                          : 'cursor-pointer'
                      "
                    >
                      <img src="/static/images/icons/plus_icon_blue.svg" class="margin-icon" />
                      <span class="admin-features-label">Upload New</span>
                    </span>
                    <button
                      v-if="featuredContent"
                      class="featured-content-delete cursor-pointer"
                      @click="deleteFeaturedContentHeadline"
                    >
                      <img src="/static/images/icons/delete_icon.svg" class="margin-icon" />
                      <span class="admin-features-label delete">Delete</span>
                    </button>
                    <el-popover
                      v-if="allFeaturedContent.length >= 12"
                      class="cursor-pointer"
                      placement="bottom-end"
                      trigger="click"
                      @show="infoActive = true"
                      @hide="infoActive = false"
                      width="350"
                    >
                      <div class="limit_popover_txt word-break text-start">
                        Max limit of 12 FC entries. Please delete past entries.
                      </div>
                      <img
                        class="info-img"
                        src="/static/images/icons/info_icon.svg"
                        v-if="!infoActive"
                        slot="reference"
                      />
                      <img
                        class="info-img"
                        src="/static/images/icons/info_icon_active.svg"
                        v-if="infoActive"
                        slot="reference"
                      />
                    </el-popover>
                  </span>
                  <!-- <span class="date-title" v-if="featuredContent && windowWidth > 600">
                    {{ featuredContent.start_date | UTCDate('MMM DD') }}
                  </span> -->
                </span>
              </div>
              <span class="date-title" v-if="featuredContent && windowWidth <= 600">
                {{ featuredContent.start_date | UTCDate('LL') }}
              </span>
              <div class="webinar-header" v-if="featuredContent">
                <div class="card d-flex flex-row flex-wrap">
                  <div class="card-header">
                    <img
                      :src="getImageUrl(featuredContent.image)"
                      class="webinar-card"
                      alt="webinar-img"
                    />
                  </div>
                  <div class="px-2 sub-content-header word-break">
                    <span class="date-title" v-if="featuredContent && windowWidth > 600">
                      {{ featuredContent.start_date | UTCDate('LL') }}
                    </span>
                    <div
                      class="sub-content-1 text-emergo-dark-blue"
                      :class="{ 'url-hover': featuredContent.redirection_url }"
                    >
                      <a href="javascript:void(0);" v-if="!featuredContent.redirection_url">
                        <span>{{ featuredContent.title }}</span>
                      </a>
                      <router-link
                        :to="getPathFromURL(featuredContent.redirection_url)"
                        v-else-if="
                          featuredContent.redirection_url &&
                          selfURL(featuredContent.redirection_url)
                        "
                      >
                        <span>{{ featuredContent.title }}</span>
                      </router-link>
                      <a
                        :href="featuredContent.redirection_url"
                        target="_blank"
                        v-else-if="
                          featuredContent.redirection_url &&
                          !selfURL(featuredContent.redirection_url)
                        "
                      >
                        <span>{{ featuredContent.title }}</span>
                      </a>
                    </div>
                    <div class="sub-content-2">
                      <span v-html="featuredContent.description"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 plr-4 invalid-content"
                v-if="!featuredContent"
              >
                <div class="sub-content-2 pb-20 pt-10 bt-20">
                  <span>We currently have no upcoming events, please follow us in this space.</span>
                </div>
              </div>
              <div
                v-if="(roleId === 5 || roleId === 7) && allFeaturedContent.length"
                :class="{ 'remove-bottom': !allFeaturedContent.length }"
                class="featured-content-footer position-relative d-flex justify-content-end"
              >
                <span @click="openEditPopup('Featured Content')" class="cursor-pointer"
                  >&nbsp;&nbsp;
                  <span class="admin-features-label see-all-label">See All</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <default-modal
      :defaultMessage="isDashboardNotification"
      :isDashboardCustomizable="isDashboardCustomizable"
      v-show="isDashboardNotification && isDashboardNotification != null"
    ></default-modal>
    <delete-head-line-popup
      @refreshHeadLinesList="getRegulatoryHeadlines"
      :selectedHeadlines="featuredContent ? [featuredContent.id] : []"
      headLineType="featuredcontent"
    ></delete-head-line-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import { sortBy } from 'lodash';
import moment from 'moment';
import { Popover } from 'element-ui';
import { getNotifications } from '../../apis/notification';
import {
  getMainHeadlines,
  getCurrentFeaturedContents,
  getAllFeaturedContent
} from '../../apis/dashboard';
import { getServiceDesc } from '../../apis/marketPlace';
import { getCountriesList } from '../../apis/countriesList';
import getSasToken from '../../apis/sasToken';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';
import DefaultModal from '../Common/DefaultModal.vue';
import CarouselWidget from './CardComponents/DashboardWidgets/CarouselWidget.vue';
import DeleteHeadLinePopup from './Actions/DeleteHeadLinePopup.vue';

export default {
  props: {
    account_id: Number,
    roleId: Number,
    userId: Number,
    isDashboardNotification: Object,
    isDashboardCustomizable: Boolean,
    isDefault: Boolean
  },
  data() {
    return {
      headlineIndex: 0,
      regulatoryHeadlines: [],
      notificationsList: [],
      featuredContent: '',
      loaderStatus: false,
      services: [],
      topService: {},
      remainingServices: [],
      infoActive: false,
      sasToken: '',
      defaultMessage: 'Your subscribed service has expired, please customize your dashboard again.',
      headlines: [],
      allFeaturedContent: [],
      operationForAdd: {},
      countriesData: {
        countries: []
      },
      country: '',
      propId: 'FC',
      windowWidth: window.innerWidth
    };
  },

  components: {
    Loader,
    DefaultModal,
    CarouselWidget,
    'el-popover': Popover,
    DeleteHeadLinePopup
  },
  computed: {
    /**
     * neHeadlineIndex()
     * Return headline index for new headline
     */
    neHeadlineIndex() {
      let index = 0;
      this.regulatoryHeadlines.forEach((value) => {
        index = index < value.headlines_index ? value.headlines_index : index;
      });
      index += 1;
      return index;
    }
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    checkHeadLinesResponse(response) {
      if (response.status_code === 200) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Regulatory Headline deleted successfully',
          group: 'custom-notification'
        });
        $(`#modal_delete${this.propId}`).modal('hide');
        this.getRegulatoryHeadlines();
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Deletion of record failed',
          group: 'custom-notification'
        });
      }
    },
    getPathFromURL(url) {
      if (this.selfURL(url)) return new URL(url).pathname;
      return '';
    },
    selfURL(url) {
      return url && url.includes(window.location.hostname);
    },
    /* getNotificationSummary method to get the latest 2 notifications */
    async getNotificationSummary() {
      this.notificationsList = [];
      const notifications = await getNotifications(2);
      this.notificationsList = notifications;
      if (notifications.length > 0) {
        const notificationdates = [];
        notifications.forEach((notification) => {
          if (notificationdates.indexOf(notification.creation_date) === -1) {
            notificationdates.push(notification.creation_date);
          }
        });
        this.notificationsList = notificationdates.map((date) => {
          const notificationsPerDate = {
            date,
            notifications: notifications.filter((eachNotification) => {
              Object.assign(eachNotification, {
                icon: eachNotification.country_code
                  ? `flag-icon-${eachNotification.country_code.toLowerCase()}`
                  : ''
              });
              return eachNotification.creation_date === date;
            })
          };
          return notificationsPerDate;
        });
      }
    },
    deleteFeaturedContentHeadline() {
      $('#delete-headline-popup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    getPythonFormData(filePath) {
      const pathArray = filePath.split('/');
      const fileName = this.filterStringForSpecialCharacters(pathArray.pop());
      const folderName = this.filterStringForSpecialCharacters(pathArray.pop());
      return {
        file_name: fileName,
        // folder_name: folderName,
        permissions: 'read',
        container_name: folderName,
        storage_name: 'rams-storage-python'
      };
    },
    /* filterStringForSpecialCharacters()
     *  replaces the encoded characters from a string
     */
    filterStringForSpecialCharacters(str) {
      return str
        .replace(/%21/g, '!')
        .replace(/%27/g, "'")
        .replace(/%28/g, '(')
        .replace(/%29/g, ')')
        .replace(/%2A/g, '*')
        .replace(/%20/g, ' ');
    },
    async getRegulatoryHeadlines() {
      this.loaderStatus = true;
      const [mainHeadlines, miniHeadlines] = await Promise.all([
        getMainHeadlines(),
        getCurrentFeaturedContents()
      ]);
      this.regulatoryHeadlines = mainHeadlines.data;
      $('#myCarousel').carousel(0);
      this.loaderStatus = false;
      this.featuredContent = miniHeadlines.data;
      this.allFeaturedContent = [];
      $('#delete-headline-popup').modal('hide');
      if (this.roleId === 5 || this.roleId === 7) {
        const allFeaturedContent = await getAllFeaturedContent();
        this.allFeaturedContent = allFeaturedContent.data || [];
      }
    },
    nextHeadline(index) {
      this.headlineIndex = index;
    },
    async getJavaSasToken() {
      const formData = {
        container_name: 'market-place',
        file_name: '',
        folder_name: '',
        permissions: 'read',
        storage_name: 'rams-storage-java'
      };
      const token = await getSasToken(formData);
      this.sasToken = token;
    },
    getImageUrl(filePath, tokenRequired) {
      if (filePath) {
        if (tokenRequired) {
          return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}${this.sasToken}`;
        }
        return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}`;
      }
      return null;
    },
    async getServiceDesc() {
      this.services = await getServiceDesc();
      this.services = sortBy(this.services, 'sequence');
      this.remainingServices = this.services.filter(
        (service, index) => service.sequence < 7 && index !== 0
      );
      this.remainingServices.length = 4;
      // this.topService = this.services.find((service, index) => index === 0);
      this.topService = {
        description:
          'Interested in a particular market?  Resource Explorer let’s you browse RAMS services by country',
        icon_location: '/static/images/icons/Resources_info_icon.svg',
        id: 6,
        image_location: '/static/images/productclassification/laptop_with_map.png',
        name: 'Product Classification',
        sequence: 1
      };
    },
    learnMore(id) {
      EventBus.$emit('activeMenuTitle', this.$route.meta.title);
      this.$router.push({ path: `/layout/market-place/service/${id}` });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    /**
     * openAddPopup()
     * Open the modal popup
     */
    openAddPopup(type) {
      const paramType = type.replace(/ /g, '').toLowerCase();
      this.$router.push(`${this.$route.path}/${paramType}/add`);
    },

    openEditPopup(type) {
      const paramType = type.replace(/ /g, '').toLowerCase();
      this.$router.push(`${this.$route.path}/${paramType}`);
    },

    redirect(url, query) {
      if (query) {
        this.$router.push({ path: url, query: { country: query } });
      } else {
        this.$router.push({ path: url });
      }
      EventBus.$emit('activeMenuTitle', this.$route.meta.title);
    },
    redirectToAccSettings() {
      EventBus.$emit('notificationSettings', 'dashboard');
    },
    async intialAPIs() {
      try {
        this.loaderStatus = true;
        await Promise.all([
          this.getJavaSasToken(),
          this.getServiceDesc(),
          this.getNotificationSummary(),
          this.getCountriesList(),
          this.getRegulatoryHeadlines()
        ]);
        this.loaderStatus = false;
      } catch (err) {
        this.loaderStatus = false;
      }
      $('#myCarousel').carousel();
      $('#myCarousel').bind('slid.bs.carousel', () => {
        this.headlineIndex = $('.item.active').index() - 1;
      });
    },

    /* getCountriesList()
     * to get the countrieslist and prepopulate the country name as default country or
     * country name as first country in countrieslist
     */
    async getCountriesList() {
      // this.loaderStatus = true;
      this.countriesData = await getCountriesList();
      // this.loaderStatus = false;
    },
    /* countrySelected()
     * to fire GA event when country is selected.
     */
    async countrySelected() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Dropdown Selected',
        dropdownValue: this.country,
        dropdownName: 'Country Dropdown'
      });
    }
  },
  watch: {
    isDashboardNotification() {
      if (this.isDashboardNotification && this.isDashboardNotification !== null) {
        $('#defaultMsgModal').modal('show');
      }
    }
  },
  async created() {
    await this.intialAPIs();
  },
  async mounted() {
    EventBus.$on('initializePage', async (data) => {
      if (data) {
        await this.intialAPIs();
      }
    });
    // this.openWelcomePopup();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  filters: {
    formatDate(date, exisitngformat, format) {
      return date ? moment(date, exisitngformat).format(format) : '';
    },
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    }
  }
};
</script>
<style lang="scss" scoped>
.text-start {
  text-align: start;
}
.dashboard-container {
  font-family: Roboto;
  font-style: normal;
  background: #f2f2f2;
  min-height: 100vh;
  height: 100%;
  overflow-y: clip;
  .marketplace-right {
    padding-left: 0;

    .marketing-widget {
      background: $white;
      box-shadow: $tertiary-box-shadow;
      border-radius: $radius10;
      padding-bottom: 2px;

      .starting-marketplace {
        padding: 24px;
        background: $primary;
        border-top-right-radius: $radius10;
        border-top-left-radius: $radius10;

        .market-title {
          font-weight: $font-weight-medium;
          font-size: $font-22;
          line-height: 24px;
          color: $white;
          grid-gap: 14px;
          padding-bottom: 14px;

          .new-image {
            background: $primary;
            border: 2px solid $white;
            box-sizing: border-box;
            border-radius: 35px;
            padding: 2px 8px;
            font-weight: $font-weight-bold;
            font-size: $font-16;
            line-height: 19px;
            color: $white;
            margin-right: 10px;
          }
        }
        .market-place-line {
          .laptop-image {
            width: 100%;
          }

          .pt-12 {
            padding-top: 12px;

            .sub-doc {
              font-weight: $font-weight-400;
              font-size: $font-16;
              line-height: 20px;
              color: $white;
            }
          }
        }
        .marketplace-smart-builder {
          padding-top: 22px;

          ::v-deep {
            .el-select {
              .el-input {
                .el-select__caret {
                  font-weight: $font-weight-bold;
                }
              }
            }
          }

          .smart-builder {
            .countries_select_list {
              display: unset;

              ::v-deep {
                .el-input__icon {
                  line-height: 30px;
                }
                .el-input__inner {
                  padding-left: 12px;
                  border-radius: $radius20;
                  height: 32px;
                  width: 100% !important;
                  font-weight: $font-weight-medium;
                  color: $primary;
                  line-height: 20px;
                  font-size: $font-16;
                }
                .el-select {
                  width: 100%;
                }
                .el-input__inner:focus {
                  border-color: $primary;
                }
              }

              > .is-focus > .el-input__inner {
                border-color: $primary;
              }
              .country-label {
                color: $white;
                font-size: $font-14;
                font-weight: $font-weight-400;
                line-height: 16px;
                margin-bottom: 6px;
              }

              .multiselect-single-dropdown {
                ::v-deep {
                  .multiselect__content-wrapper {
                    -webkit-transition: none;
                    transition: none;
                    &:hover {
                      &::-webkit-scrollbar-track {
                        box-shadow: none;
                      }
                    }
                  }
                }
              }
            }
            .margin_left {
              margin-left: auto;

              .button_go {
                position: absolute;
                bottom: 0px;
                right: 0px;
                padding: 6px 20px;
              }
            }
          }
        }
      }

      .last-marketplace {
        font-weight: $font-weight-medium;
        font-size: $font-22;
        line-height: 24px;
        color: $primary;
        padding: 24px;

        .premium-services {
          font-weight: $font-weight-medium;
          font-size: $font-22;
          line-height: 20px;
          color: $primary;
        }

        .main-reg-intel {
          margin-top: 24px;

          .market-img {
            box-sizing: border-box;
            max-width: 32px;
            min-width: 32px;
            height: 32px;
            margin-right: 12px;

            img {
              width: 100%;
              display: block;
              margin-left: auto;
              margin-right: auto;
            }

            &.market-img-gg {
              background: #67b1e2;
              border: 1px solid #67b1e2;
            }
          }

          .premium-regulatory {
            font-weight: $font-weight-bold;
            font-size: $font-16;
            line-height: 19px;
            color: $secondary;

            .sub-category {
              color: $secondary;
              font-style: normal;
              font-weight: $font-weight-400;
              font-size: $font-20;
              line-height: 23px;
              cursor: pointer;
            }

            .pt-12 {
              padding-top: 12px;

              .sub-premium {
                font-weight: $font-weight-400;
                font-size: $font-16;
                line-height: 19px;
                color: rgba(0, 0, 0, 0.7);
              }
            }
          }
        }
      }

      .marketplace-see-more {
        position: absolute;
        bottom: 24px;
        right: 40px;
      }
    }
  }

  .notification-widget,
  .upcoming-widget {
    .widget-card {
      flex-direction: column;
      padding: 24px;
      padding-right: 0;
      background: $white;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
      border-radius: $radius10;
      min-height: 150px;

      .header {
        box-sizing: border-box;
        border-radius: 10px 10px 0px 0px;
        align-items: center;
        padding-right: 24px;

        > img {
          width: 32px;
          height: 32px;
        }

        .title {
          font-family: Roboto;
          font-weight: $font-weight-medium;
          color: $primary;
          padding-left: 16px;
          font-size: $font-22 !important;
          line-height: 26px !important;
        }
      }
      .featured-content-footer {
        bottom: 19px;
        background: $white;
        position: absolute;
        right: 24px;
        margin-right: 2px;

        &.remove-bottom {
          bottom: unset !important;
        }

        span {
          color: $messenger-blue;
          font-weight: $font-weight-medium;
        }
      }
      &.noti-ht {
        height: 230px;
      }
    }
  }

  .notification-widget {
    position: relative;
    margin-top: 25px;
    .each-notification {
      margin-bottom: 32px;
      img {
        width: 20px;
        height: 20px;
      }

      .notification-date-css {
        font-weight: $font-weight-medium;
        font-size: $font-16;
        padding-right: 0px;
        text-align: left;
        line-height: 19px;
        color: rgba(0, 0, 0, 0.7);
      }

      .notification_text_block {
        &:hover {
          overflow-y: auto;
        }
        .flag-icon {
          font-size: $font-20;
        }
        .img-size {
          width: 24px;
          height: 24px;
        }

        .notification-details {
          font-family: Roboto;
          font-size: $font-16;
          font-weight: normal;
          line-height: 19px;
          color: rgba(0, 0, 0, 0.7);
        }
      }
    }

    .footer {
      position: absolute;
      bottom: 24px;
      right: 24px;
    }
  }

  .upcoming-widget {
    margin-top: 24px;

    .admin-features {
      font-size: $font-16;
      line-height: 19px;
      text-align: right;
      color: $primary;
      padding: 0px;
      flex: auto;

      .margin-icon {
        margin-right: 9px;
        padding-bottom: 2px;
        height: 18px;
        width: 18px;
      }

      .featured-content-delete {
        margin-left: 24px;
        padding: 0;
        background: none;
        border: none;
        .delete {
          color: $deep-thick-danger;
        }
      }

      .limit_popover_txt {
        text-align: left;
        word-break: break-word;
      }

      .info-img {
        height: 18px;
        width: 18px;
        margin-left: 6px;
      }
    }
    .date-title {
      font-size: $font-16;
      line-height: 19px;
      color: rgba(0, 0, 0, 0.7);
      text-align: right;
      font-weight: 500;
    }
    .webinar-header {
      padding-top: 23px;
      padding-bottom: 18px;

      .webinar-card {
        padding-right: 11px;
      }

      .sub-content-header {
        padding-left: 20px;
        height: 125px;
        width: 100%;
        overflow-y: auto;
        scrollbar-width: none;
        padding-bottom: 24px;
        padding-right: 15px;

        &:hover {
          scrollbar-width: thin;
        }

        .sub-content-1 {
          font-weight: $font-weight-400;
          font-size: $font-20;
          line-height: 23px;
          padding: 16px 0;
          a {
            color: $primary !important;
          }
          &.url-hover {
            a {
              &:hover {
                text-decoration: underline !important;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  .see-more {
    font-size: $font-16;
    line-height: 19px;
    color: $messenger-blue;
    float: right;
    cursor: pointer;
    font-weight: $font-weight-medium;
  }

  .invalid-content {
    height: 100%;
  }
  .sub-content-2 {
    font-weight: $font-weight-400;
    font-size: $font-16;
    line-height: 19px;
    color: rgba(0, 0, 0, 0.7);
    text-align: justify;
  }

  .mr-12 {
    margin-right: 12px;
  }

  .pl-14 {
    padding-left: 14px;
  }

  .plr-4 {
    padding: 0 4px;
  }

  .cursor-pointer-disable {
    cursor: not-allowed;
  }

  ::-webkit-scrollbar {
    width: 0px;
  }
  :hover::-webkit-scrollbar {
    width: 5px;
  }
}

@media screen and (max-width: 767px) {
  .dashboard-container {
    .marketplace-right {
      margin-top: 25px;
      padding-left: 15px;
      .marketing-widget {
        padding-bottom: 25px;
        .market-title {
          padding-left: 0px;
        }
        .smart-builder {
          padding-bottom: 20px !important;
        }
      }
    }

    .upcoming-widget {
      .admin-features {
        font-size: $font-12;
        margin-left: auto;
        min-width: 60px;
        flex: unset;
        > span {
          display: flex;
          justify-content: space-between;
        }
        .admin-features-label {
          display: none;
          left: 85%;
        }
        .margin-icon {
          margin: 0;
          padding-bottom: 0;
        }
        .featured-content-delete {
          margin-left: 0px;
          padding: 0;
        }
        .info-img {
          margin-right: 10px;
        }
        .cursor-pointer {
          &:first-child {
            padding-right: 0px;
          }
        }
      }
    }
    .webinar-header {
      padding-right: 0px;
      .card.flex-row.flex-wrap {
        display: block !important;
        .card-header {
          text-align: center;
          .webinar-card {
            padding-right: 21px;
            width: 100%;
          }
        }
        .sub-content-header {
          padding-top: 22px;
          padding-left: 0;
        }
      }
    }
    .featured-content-footer {
      bottom: 0px;
    }
  }
}

@media (max-width: 1024px) {
  .dashboard-container {
    .upcoming-widget {
      .webinar-header {
        padding-bottom: 10px;
        padding-right: 0;
      }
    }
  }
}

@media (max-width: 600px) {
  .dashboard-container {
    .upcoming-widget {
      .widget-card {
        height: auto;
        padding-right: 24px;
        .header {
          margin-bottom: 15px;
          padding-right: 0;
        }

        .featured-content-footer {
          span {
            line-height: 19px;
          }
        }
      }
      .date-title {
        text-align: left;
      }
      .webinar-header {
        padding-bottom: 18px;
        padding-top: 16px;
        .card.flex-row.flex-wrap {
          .card-header {
            .webinar-card {
              padding: 0;
              height: 194px;
            }
          }
          .sub-content-header {
            padding-left: 0;
            padding-top: 8px;
            height: auto;
            overflow-y: unset;

            .sub-content-2 {
              padding-top: 8px;
              padding-bottom: 32px;
              height: auto;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 410px) {
  .upcoming-widget {
    .widget-card {
      .header {
        align-items: flex-start !important;
        .title {
          width: 164px;
        }
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .dashboard-container {
    .marketplace-right {
      .marketing-widget {
        margin-left: 15px;
        height: 1100px;
        .starting-marketplace {
          padding: 24px;
          .market-title {
            .new-image {
              margin-right: 8px;
              font-size: $font-14;
              line-height: 17px;
            }
          }
        }
        .last-marketplace {
          padding-bottom: 15px;
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .dashboard-container {
    .notification-details {
      font-size: $font-14 !important;
    }

    .date-title {
      text-align: right;
      padding-right: 0;
    }

    .featured-content-footer {
      bottom: 0px;
    }
  }
}

@media screen and (min-width: 992px) {
  .marketplace-right {
    float: right !important;
  }
}
@media screen and (max-width: 991px) {
  .marketplace-right {
    margin-top: 25px !important;
  }
}
@media screen and (min-width: 1281px) and (max-width: 2000px) {
  .marketing-widget {
    height: 1112px !important;
  }
  .noti-ht {
    height: 260px !important;
  }
  .upcoming-widget > .widget-card {
    height: 260px !important;
  }
}
@media screen and (min-width: 2000px) {
  .marketing-widget {
    height: 1082px !important;
  }
  .upcoming-widget > .widget-card {
    height: 260px !important;
  }
}
@media (min-width: 992px) and (max-width: 1280px) {
  .dashboard-container {
    .marketing-widget {
      height: 1120px !important;
      .margin_left {
        margin-left: 25px !important;
      }
      .premium-regulatory {
        height: 95px;
        overflow-y: hidden;

        &:hover {
          overflow-y: auto;
        }
      }
    }
    .upcoming-widget {
      > .widget-card {
        height: 296px;
        .sub-content-2 {
          height: 80px;
        }
      }
    }
  }
}
@media (min-width: 1281px) and (max-width: 1300px) {
  .premium-regulatory {
    height: 80px;
    overflow-y: hidden;

    &:hover {
      overflow-y: auto;
    }
  }
}
</style>
